import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { V_URL } from "../../../../../BaseUrl";
import axios from "axios";
import Footer from "../../../Include/Footer";
import Header from "../../../Include/Header";
import Sidebar from "../../../Include/Sidebar";
import { Pagination, Search } from "../../../Table";
import moment from "moment";
import DropDown from "../../../../../Components/DropDown";
import toast from "react-hot-toast";
import Loader from "../../../Include/Loader";
import { getProIssue } from "../../../../../Store/prosafe/proTransaction/ProIssue/getProIssue";
import {
  getIssueStatusLabel,
  getStatusLabel,
} from "../../components/ProStatus/StatusFile";
import { Check, X } from "lucide-react";
import PageHeader from "../../../Components/PageHeader/PageHeader";
import { getAdminItem } from "../../../../../Store/Store/Item/AdminItem";
import { getProject } from "../../../../../Store/Store/Project/Project";
import { getCategory } from "../../../../../Store/Store/StoreMaster/Category/Category";
import useDebounce from "../../../../../hooks/useDebounce";

const IssList = () => {

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [limit, setlimit] = useState(10);

  const [filter, setFilter] = useState({
    startDate: null,
    endDate: null,
    item: null,
    category: null,
    project: null,
    item_project: null,
  });

  const debouncedSearch = useDebounce(search, 500);

  useEffect(() => {
    fetchData();
  }, [debouncedSearch, filter, currentPage, limit]);

  useEffect(() => {
    dispatch(getAdminItem({ is_main: true }));
    dispatch(getProject());
    dispatch(getCategory());
  }, [dispatch]);

  const fetchData = () => {

    const payload = {
      tag_number: 13,
      search: debouncedSearch,
      start_date: filter.startDate,
      end_date: filter.endDate,
      item_id: filter.item,
      item_category_id: filter.category,
      project_id: filter.project,
      item_project_id: filter.item_project,
      firm_id: localStorage.getItem("PAY_USER_FIRM_ID"),
      year_id: localStorage.getItem("PAY_USER_YEAR_ID"),
    }

    dispatch(getProIssue({ formData: payload }));
  };

  const entity = useSelector((state) => state?.getProIssue?.user?.data) || [];
  const isLoading = useSelector((state) => state?.getProIssue?.loading);
  const itemData = useSelector((state) => state?.getAdminItem?.user?.data);
  const projectData = useSelector((state) => state?.getProject?.user?.data);
  const categoryData = useSelector((state) => state?.getCategory?.user?.data);

  const handleFilterChange = (newFilter) => {
    setFilter(newFilter);
    setCurrentPage(1);
  };

  const handleDownloadExcel = async () => {
    try {
      const payload = {
        tag_number: 13,
        search,
        start_date: filter.startDate,
        end_date: filter.endDate,
        item_id: filter.item,
        item_category_id: filter.category,
        project_id: filter.project,
        item_project_id: filter.item_project,
        firm_id: localStorage.getItem("PAY_USER_FIRM_ID"),
        year_id: localStorage.getItem("PAY_USER_YEAR_ID"),
      };

      const res = await axios.post(
        `${V_URL}/prosafe/pro-list-iss-xlsx-download`,
        payload,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("PAY_USER_TOKEN"),
          },
        }
      );

      if (res?.data) {
        window.open(res?.data?.data?.url);
        toast.success(res?.data?.message || "Excel downloaded successfully");
      } else {
        toast.error("Failed to download");
      }
    } catch (err) {
      console.log(err);
      toast.error(err?.response?.data?.message || "Download failed");
    }
  };

  const commentsData = useMemo(() => {
    let data = [...entity];
    setTimeout(() => setTotalItems(data.length), 0);
    return data.slice(
      (currentPage - 1) * limit,
      (currentPage - 1) * limit + limit
    );
  }, [entity, search, currentPage, limit]);

  const handleRefresh = () => {
    // fetchData()
    setFilter({
      startDate: null,
      endDate: null,
      item: null,
      category: null,
      project: null,
    });
  };

  const handleVerifyIssue = async (id, voucherNo, status) => {
    if (status === 3) {

      const { value: reason } = await Swal.fire({
        title: `Reject PR - ${voucherNo}`,
        input: "textarea",
        inputLabel: "Reason for Rejection",
        inputPlaceholder: "Type the rejection reason...",
        inputAttributes: {
          "aria-label": "Type your rejection reason here",
        },
        showCancelButton: true,
        confirmButtonText: "Reject",
        confirmButtonColor: "#e74c3c",
        cancelButtonColor: "#6c757d",
      });

      if (!reason) {
        Swal.fire(
          "Cancelled",
          "Rejection was cancelled or no reason was provided.",
          "info"
        );
        return;
      }

      const payload = {
        id,
        rej_reason: reason,
        status: 4,
      };

      try {
        const myurl = `${V_URL}/prosafe/pro-issue-approval`;
        await axios({
          method: "post",
          url: myurl,
          data: payload,
          headers: {
            Authorization: "Bearer " + localStorage.getItem("PAY_USER_TOKEN"),
          },
        });
        Swal.fire(
          "Rejected!",
          "Issue has been rejected.",
          "success"
        );
        fetchData();
      } catch (err) {
        console.error(err);
        Swal.fire("Error!", "Something went wrong while rejecting.", "error");
      }
    } else if (status === 2) {
      const result = await Swal.fire({
        title: `Approve Issue - ${voucherNo}`,
        text: "Are you sure you want to approve this request?",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Yes, Approve",
        confirmButtonColor: "#28a745",
        cancelButtonColor: "#d33",
      });

      if (!result.isConfirmed) return;

      const payload = {
        id,
        rej_reason: "",
        status: 3,
      };

      try {
        const myurl = `${V_URL}/prosafe/pro-issue-approval`;
        await axios({
          method: "post",
          url: myurl,
          data: payload,
          headers: {
            Authorization: "Bearer " + localStorage.getItem("PAY_USER_TOKEN"),
          },
        });
        Swal.fire(
          "Approved!",
          "Issue has been approved.",
          "success"
        );
        fetchData();
      } catch (err) {
        console.error(err);
        Swal.fire("Error!", "Something went wrong while approving.", "error");
      }
    }
  };

  const handleDelete = (id, title) => {
    Swal.fire({
      title: `Are you sure want to delete ${title}?`,
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        const myurl = `${V_URL}/prosafe/pro-delete-iss`;
        var bodyFormData = new URLSearchParams();
        bodyFormData.append("id", id);
        axios({
          method: "put",
          url: myurl,
          data: bodyFormData,
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Authorization: "Barrer " + localStorage.getItem("PAY_USER_TOKEN"),
          },
        })
          .then((response) => {
            if (response.data.success === true) {
              toast.success(response?.data?.message);
              fetchData();
            } else {
              toast.error(response?.data?.message);
            }
          })
          .catch((error) => {
            toast.error(
              error?.response?.data?.message || "Something went wrong"
            );
          });
      }
    });
  };

  const handleIssueDownload = async (id) => {
    try {
      const res = await axios.post(
        `${V_URL}/prosafe/download-issue-slip/${id}`,
        {},
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("PAY_USER_TOKEN"),
          },
        }
      );
      if (res?.data?.success === true) {
        window.open(res?.data?.data?.pdfUrl);
        toast.success(res?.data?.message);
      } else {
        toast.error(res?.data?.message || "Something went wrong");
      }
    } catch (err) {
      console.log(err);
    }
  };

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const handleOpen = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const breadCrumbs = [
    { label: "Dashboard", link: "/main-store/user/dashboard" },
    { label: "Issue" },
  ];

  const filterConfig = [
    {
      key: "item",
      label: "Item",
      type: "dropdown",
      value: filter.item,
      placeholder: "Select Item",
      searchable: true,
      options:
        itemData?.map((item) => ({ label: item.name, value: item._id })) || [],
    },
    {
      key: "category",
      label: "Item Category",
      type: "dropdown",
      value: filter.category,
      placeholder: "Select Item Category",
      searchable: true,
      options:
        categoryData?.map((category) => ({
          label: category.name,
          value: category._id,
        })) || [],
    },
    {
      key: "project",
      label: "Project (Old Issue)",
      type: "dropdown",
      value: filter.project,
      placeholder: "Select Project",
      searchable: true,
      options:
        projectData?.map((project) => ({
          label: `${project.name} (${project.project_no})`,
          value: project._id,
        })) || [],
    },
    {
      key: "item_project",
      label: "Item Project (New Issue)",
      type: "dropdown",
      value: filter.item_project,
      placeholder: "Select Item Project",
      searchable: true,
      options:
        projectData?.map((project) => ({
          label: `${project.name} (${project.project_no})`,
          value: project._id,
        })) || [],
    },
    {
      key: "startDate",
      label: "Start Date",
      type: "date",
      value: filter.startDate,
      placeholder: "Select Start Date",
    },
    {
      key: "endDate",
      label: "End Date",
      type: "date",
      value: filter.endDate,
      placeholder: "Select End Date",
    },
  ];

  return (
    <div className={`main-wrapper ${isSidebarOpen ? "slide-nav" : ""}`}>
      <Header handleOpen={handleOpen} />
      <Sidebar />
      <div className="page-wrapper">
        <div className="content">

          <div className="row">
            <div className="col-sm-12">
              <div className="card card-table show-entire">
                <div className="card-body">

                  <PageHeader
                    title="Issue"
                    breadcrumbs={breadCrumbs}
                    onSearch={(value) => {
                      setSearch(value);
                      setCurrentPage(1);
                    }}
                    addButtonLink="/main-store/user/manage-issue"
                    onRefresh={handleRefresh}
                    filter={filter}
                    onFilterChange={handleFilterChange}
                    limit={limit}
                    onLimitChange={(val) => setlimit(val)}
                    filterConfig={filterConfig}
                    onDownload={handleDownloadExcel}
                  />

                  {!isLoading ? (
                    <div className="table-responsive">
                      <table className="table border-0 custom-table comman-table  mb-0">
                        <thead>
                          <tr>
                            <th>Sr.</th>
                            <th>Issue Date</th>
                            <th>Issue No.</th>
                            <th>Total Qty</th>
                            {/* <th>Party</th> */}
                            <th>Project</th>
                            {/* <th>Project No</th> */}
                            <th>Received By</th>
                            <th>Approved By</th>
                            {/* <th>Transport</th> */}
                            {/* <th>Item Count</th> */}
                            {/* <th>Total Amount</th> */}
                            <th>Status</th>
                            <th>Acc/Rej</th>
                            <th className="text-end">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {commentsData?.map((elem, i) => (
                            <tr key={elem?._id}>
                              <td>{(currentPage - 1) * limit + i + 1}</td>
                              <td>
                                {moment(elem?.receive_date).format(
                                  "YYYY-MM-DD"
                                )}
                              </td>
                              <td>{elem.voucher_no}</td>
                              <td>{elem.total_qty || 0}</td>
                              {/* <td>{elem.party_data?.name || "-"}</td> */}
                              <td>
                                {elem.item_projects?.length
                                  ? elem.item_projects.map((p, i) => (
                                    <div key={i}>
                                      {p.project_no ? `${p.name} ${p.project_no ? "(" + p.project_no + ")" : ""}` : ""}
                                    </div>
                                  ))
                                  : elem.project_data?.project_no
                                    ? `${elem.project_data.name} ${elem.project_data.project_no ? "(" + elem.project_data.project_no + ")" : ""}`
                                    : "-"
                                }
                              </td>
                              {/* <td>{elem?.manual_pro_no || "-"}</td> */}
                              {/* <td>{elem?.project_data?.project_no}</td> */}
                              <td>{elem?.issue_by?.name}</td>
                              <td>{elem.issueVerifyBy?.name || "-"}</td>
                              {/* <td>{elem?.transport_data?.name || "-"}</td> */}
                              {/* <td>{elem.item_count || 0}</td> */}
                              {/* <td>{elem.total_amount?.toFixed(2) || 0}</td> */}

                              <td>{getStatusLabel(elem?.status)}</td>
                              <td className="d-flex gap-2">
                                {elem.status === 1 ? (
                                  <>
                                    <span
                                      className="present-table attent-status"
                                      style={{ cursor: "pointer" }}
                                      onClick={() =>
                                        handleVerifyIssue(
                                          elem._id,
                                          elem?.voucher_no,
                                          2
                                        )
                                      }
                                    >
                                      <Check />
                                    </span>
                                    <span
                                      className="absent-table attent-status"
                                      style={{ cursor: "pointer" }}
                                      onClick={() =>
                                        handleVerifyIssue(
                                          elem._id,
                                          elem?.voucher_no,
                                          3
                                        )
                                      }
                                    >
                                      <X />
                                    </span>
                                  </>
                                ) : (
                                  <X />
                                )}
                              </td>
                              <td className="text-end">
                                <div className="dropdown dropdown-action">
                                  <a
                                    href="#"
                                    className="action-icon dropdown-toggle"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                  >
                                    <i className="fa fa-ellipsis-v"></i>
                                  </a>
                                  <div className="dropdown-menu dropdown-menu-end">
                                    <button
                                      type="button"
                                      className="dropdown-item"
                                      onClick={() =>
                                        navigate(
                                          `/main-store/user/view-issue`,
                                          { state: elem }
                                        )
                                      }
                                    >
                                      <i className="fa-solid fa-eye m-r-5"></i>{" "}
                                      View
                                    </button>

                                    {elem?.status !== 3 && (
                                      <button
                                        type="button"
                                        className="dropdown-item"
                                        onClick={() =>
                                          navigate(
                                            `/main-store/user/manage-issue`,
                                            { state: elem }
                                          )
                                        }
                                      >
                                        <i className="fa-solid fa-pen-to-square m-r-5"></i>{" "}
                                        Edit
                                      </button>
                                    )}

                                    {/* {elem?.status === 1 && ( */}
                                      <button
                                        type="button"
                                        className="dropdown-item"
                                        onClick={() =>
                                          handleDelete(
                                            elem?._id,
                                            elem.voucher_no
                                          )
                                        }
                                      >
                                        <i className="fa fa-trash-alt m-r-5"></i>{" "}
                                        Delete
                                      </button>
                                    {/* )} */}
                                    {/* {elem?.status === 1 && (
                                      <button
                                        type="button"
                                        className="dropdown-item"
                                        onClick={() =>
                                          handleVerifyIssue(
                                            elem?._id,
                                            elem?.voucher_no
                                          )
                                        }
                                      >
                                        <i className="fa fa-check m-r-5"></i>{" "}
                                        Verify Issue
                                      </button>
                                    )} */}

                                    <button
                                      type="button"
                                      className="dropdown-item"
                                      onClick={() =>
                                        handleIssueDownload(elem?._id)
                                      }
                                    >
                                      <i className="fa-solid fa-download m-r-5"></i>{" "}
                                      download
                                    </button>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          ))}
                          {commentsData?.length === 0 ? (
                            <tr>
                              <td colSpan="999">
                                <div className="no-table-data">
                                  No Data Found!
                                </div>
                              </td>
                            </tr>
                          ) : null}
                        </tbody>
                      </table>
                    </div>
                  ) : (
                    <Loader />
                  )}

                  <div className="row align-center mt-3 mb-2">
                    <div className="col-sm-12 col-md-6 col-lg-6 col-xxl-6">
                      <div
                        className="dataTables_info"
                        id="DataTables_Table_0_info"
                        role="status"
                        aria-live="polite"
                      >
                        Showing {Math.min(limit, totalItems)} from{" "}
                        {totalItems} data
                      </div>
                    </div>
                    <div className="col-sm-12 col-md-6 col-lg-6 col-xxl-6 ">
                      <div
                        className="dataTables_paginate paging_simple_numbers"
                        id="DataTables_Table_0_paginate"
                      >
                        <Pagination
                          total={totalItems}
                          itemsPerPage={limit}
                          currentPage={currentPage}
                          onPageChange={(page) => setCurrentPage(page)}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
        <Footer />
      </div>
    </div>
  );
};

export default IssList;
